import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=61ed3038&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports